import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SiteInfo {
  id: number;
  name: string;
}

interface InspectionOverviewState {
  siteInfo: SiteInfo[];
}

const initialState: InspectionOverviewState = {
  siteInfo: [],
};

const InspectionOverview = createSlice({
  name: "InspectionOverview",
  initialState,
  reducers: {
    SiteInfoReducer: (state, action: PayloadAction<SiteInfo[]>) => {
      state.siteInfo = action.payload;
    }
  }
});

export const { SiteInfoReducer } = InspectionOverview.actions;

export default InspectionOverview;
